import React from 'react';
import { PillButton } from 'library/ui';
import { ButtonContainer } from '../components/Containers';

export default function MainButtons({
    onSetPreferredClick,
    onNoClick,
}: {
    onSetPreferredClick: () => void;
    onNoClick: () => void;
}) {
    return (
        <ButtonContainer>
            <PillButton variant="secondary" onClick={onNoClick}>
                No, not right now
            </PillButton>
            <PillButton onClick={onSetPreferredClick}>Yes, please add</PillButton>
        </ButtonContainer>
    );
}
